<template>

    <div class="authors-bag">
        <div class="position-relative">
            <div class="position-absolute site-navigation-wrap" :class="{'button-close-wrap': displayAuthorsBag}">
                <!-- Questo è il pulsante che al click mostra o nasconde la lista dei talenti col popup e quel che è. -->
                <button @click="displayAuthorsBag = !displayAuthorsBag" class="menu-circle d-flex align-items-center justify-content-center">
                    <span><span></span></span>
                </button>
            </div>
            <nav :class="{'is-open': displayAuthorsBag}" class="site-navigation d-flex flex-column justify-content-center">
                <!-- la condizione per visualizzare la lista la puoi spostare anche su un eventuale contenitore -->
                <!-- display_authors_bag è true quando bisogna visualizzare e false quando nascondere, d-none viene di conseguenza. -->
                <ul class="h-auto site-navigation-list list-unstyled mb-0" style="padding-top: 10px;padding-bottom: 10px;">
                    <li v-for="author in authors_bag">
                        <Link :href="`/talenti/${author.slug}`" @click="displayAuthorsBag=!displayAuthorsBag">
                            <p v-text="author.name" class="ff-sans fw-400 fz-18 color-white"></p>
                        </Link>
                    </li>
                </ul>
            </nav>
            <Link href="/" :class="{'menu-is-open': displayAuthorsBag}" class="link-brand">
                <figure class="mb-0 nav-brand-wrap">
                    <img src="/client/images/psam-logo-vertical.png"
                         alt="PS Artists Management Logo"
                         class="">
                    <figcaption class="visually-hidden">PS Artists Management</figcaption>
                </figure>
            </Link>
        </div>

    </div>

</template>

<script>
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    name: "Header",

    setup() {
        const authors_bag = computed(() => usePage().props.value.authors_bag);
        return {authors_bag};
    },

    data() {
        return {
            displayAuthorsBag: false,
        };
    },

    watch:{
        displayAuthorsBag(new_val, old_val) {
            if (new_val) {
                document.querySelector('html').classList.add('nav-is-open');
                document.querySelector('body').classList.add('nav-is-open');
            }
            else {
                document.querySelector('html').classList.remove('nav-is-open');
                document.querySelector('body').classList.remove('nav-is-open');
            }
        }
    }

}
</script>

<style scoped>

</style>
